/* eslint-disable @typescript-eslint/no-explicit-any */
import api from 'libs/axios/api';
import { BASE_URL } from 'libs/axios/axiosInstance';
import { apiService } from 'libs/axios/services';

export const getContainerCategoriesFetcher = async (
    params: URLSearchParams,
): Promise<ApiResponse<IGetContainerCategoriesRes>> => {
    return apiService.get<URLSearchParams, IGetContainerCategoriesRes>(
        `${BASE_URL}/container-category/list`,
        params,
        undefined,
        true,
    );
};

export const createContainerCategoryFetcher = async (
    body: ICreateUpdateContainerCategoryReq,
): Promise<ApiResponse<ICreateUpdateDeleteCategoryRes>> => {
    return apiService.post<ICreateUpdateContainerCategoryReq, ICreateUpdateDeleteCategoryRes>(
        `${BASE_URL}/container-category/`,
        body,
        undefined,
        true,
    );
};

export const updateContainerCategoryFetcher = async (
    id: string,
    body: ICreateUpdateContainerCategoryReq,
): Promise<ApiResponse<ICreateUpdateDeleteTaskRes>> => {
    return apiService.put<ICreateUpdateContainerCategoryReq, ICreateUpdateDeleteTaskRes>(
        `${BASE_URL}/container-category/${id}`,
        body,
        undefined,
        true,
    );
};

export const deleteContainerCategoryFetcher = async (
    category_ids: string[],
): Promise<ApiResponse<ICreateUpdateDeleteUserRes>> => {
    const idsToDelete = { category_ids };
    return apiService.delete<typeof idsToDelete, ICreateUpdateDeleteUserRes>(
        `${BASE_URL}/container-category/bulk-delete`,
        undefined,
        idsToDelete,
        undefined,
        true,
    );
};

export const generatePresignedUrl = (
    body: IGeneratePresignedUrlReq,
    isShowLoading: boolean = true,
) => {
    return apiService.post<IGeneratePresignedUrlReq, IGeneratePresignedUrlRes>(
        `${BASE_URL}/generate-presigned-url/presigned-url`,
        body,
        undefined,
        isShowLoading,
    );
};

export const containerCategoryDownloadFetcher = async (
    request: URLSearchParams,
): Promise<ApiResponse<any>> => {
    return apiService.get<URLSearchParams, ResponseBase<any>>(
        api.containerCategoryDownload,
        request,
        {
            responseType: 'blob',
        },
    );
};
